/* eslint-disable */

import * as _ from 'lodash';

export class ExternalModal {
    urls: string[] = [];
    activeUrl: string;
    galleryItemAttribute: string;
    galleryItemIdAttribute: string;
    galleryItemContentAttribute: string;
    galleryHtml: HTMLElement;
    externalLink: HTMLElement;
    pageBody: HTMLElement;
    activeClass: string = "active";
    scrollLockClass: string = "scroll-lock";

    get activeIndex() {
        if (!this.urls) {
            return -1;
        }

        var activeItem = this.urls.filter(item => item == this.activeUrl)[0];
        return this.urls.indexOf(activeItem);
    }

    constructor(...urlsToGrab: string[]) {
        this.initializeItems(urlsToGrab);
        this.initializeGallery();
    }

    initializeGallery = () => {
        this.pageBody = document.querySelector('body');
        this.galleryHtml = document.querySelector('[data-external-link-modal]');
        this.externalLink = document.querySelector('[data-external-link]');

        var galleryClose = document.querySelector('[data-modal-close]');
        galleryClose?.addEventListener("click", (e) => {
            this.closeGallery();
        });

        this.externalLink?.addEventListener("click", (e) => {
            this.closeGallery();
        });
    }


    initializeItems = (urlsToGrab: string[]) => {
        let allAnchors = Array.prototype.slice.call(document.getElementsByTagName("a")) as HTMLElement[];
        var allFilteredAnchors = allAnchors.filter(
            a => urlsToGrab.some(url => a.getAttribute("href") && a.getAttribute("href").toLowerCase().indexOf(url.toLowerCase()) > -1));

        // bind all click events
        [].forEach.call(allFilteredAnchors, (anchor) => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.openGallery((e.currentTarget as any).href);
            });
        });

        // only load distinct items
        for (var i = 0; i < allFilteredAnchors.length; i++) {
            if (!this.urls.some(url => url === allFilteredAnchors[i].getAttribute("href"))) {
                this.urls.push(allFilteredAnchors[i].getAttribute("href"));
            }
        }
    }

    renderExternalLink = () => {
        this.externalLink.setAttribute("href", this.activeUrl);
    }

    openGallery = (url: string) => {
        this.activeUrl = url;

        if (!this.galleryHtml.classList.contains(this.activeClass)) {
            this.galleryHtml.classList.add(this.activeClass);
            this.pageBody.classList.add(this.scrollLockClass);
            
            
        }

        this.renderExternalLink();
    }

    closeGallery = () => {
        if (this.galleryHtml.classList.contains(this.activeClass)) {
            this.galleryHtml.classList.remove(this.activeClass);
            this.pageBody.classList.remove(this.scrollLockClass);
        }
    }

    nextItem = () => {
        if (this.activeIndex > -1 && this.activeIndex + 1 < this.urls.length) {
            this.activeUrl = this.urls[this.activeIndex + 1];
        }
        this.renderExternalLink();
    }

    prevItem = () => {
        if (this.activeIndex > 0) {
            this.activeUrl = this.urls[this.activeIndex - 1];
        }
        this.renderExternalLink();
    }
}

